import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import { FormButton } from 'libs/forms/styles';

const FormActionButton = props => {
  const {
    formStore,
    buttonText,
    buttonHandler,
    buttonTextPosting,
    icon = 'arrow_right',
    iconPosition = 'right',
    dataTestId,
    ...attributes
  } = props;

  return (
    <FormButton
      type='submit'
      onMouseDown={() => {
        // We should not preventDefault here!
        if (buttonHandler) buttonHandler();
      }}
      loading={formStore?.posting}
      text={formStore?.posting ? buttonTextPosting || buttonText : buttonText}
      disabled={formStore?.disabled}
      icon={icon}
      iconPosition={iconPosition}
      removeFullWidth
      data-testid={dataTestId}
      {...attributes}
    />
  );
};

FormActionButton.propTypes = {
  formStore: PropTypes.object,
  buttonText: PropTypes.string,
  buttonTextPosting: PropTypes.string,
  buttonHandler: PropTypes.func,
  icon: PropTypes.string,
  iconPosition: PropTypes.string,
  attributes: PropTypes.object,
  dataTestId: PropTypes.string,
};

export default withNamespaces()(observer(FormActionButton));
